var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-button-group-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-toggle",
          class: { wide: _vm.wide },
          attrs: { "data-toggle": "buttons" },
        },
        _vm._l(_vm.items, function (item, idx) {
          return _c(
            "label",
            {
              key: `c-group-item-${item.label}-${idx}`,
              staticClass: "btn btn-item",
              class: {
                "no-space mx-0": !_vm.separate,
                "is-invalid": _vm.error,
                [`btn-${_vm.size}`]: true,
                pill: _vm.pill,
                active: _setup.isItemActive(item),
                "font-weight-bold": !_vm.noIcon,
                disabled: item.disabled || _vm.disabled,
              },
            },
            [
              !_vm.noIcon
                ? _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: _setup.itemIcon(item) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.selectedValues,
                        expression: "selectedValues",
                      },
                    ],
                    attrs: {
                      disabled: item.disabled || _vm.disabled,
                      type: "checkbox",
                    },
                    domProps: {
                      value: item.value,
                      checked: Array.isArray(_setup.selectedValues)
                        ? _vm._i(_setup.selectedValues, item.value) > -1
                        : _setup.selectedValues,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _setup.selectedValues,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = item.value,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_setup.selectedValues = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_setup.selectedValues = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _setup.selectedValues = $$c
                        }
                      },
                    },
                  })
                : _vm.type === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.selectedValues,
                        expression: "selectedValues",
                      },
                    ],
                    attrs: {
                      disabled: item.disabled || _vm.disabled,
                      type: "radio",
                    },
                    domProps: {
                      value: item.value,
                      checked: _vm._q(_setup.selectedValues, item.value),
                    },
                    on: {
                      change: function ($event) {
                        _setup.selectedValues = item.value
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.selectedValues,
                        expression: "selectedValues",
                      },
                    ],
                    attrs: {
                      disabled: item.disabled || _vm.disabled,
                      type: _vm.type,
                    },
                    domProps: {
                      value: item.value,
                      value: _setup.selectedValues,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _setup.selectedValues = $event.target.value
                      },
                    },
                  }),
              _vm._v("\n            " + _vm._s(item.label) + "\n        "),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.error
        ? _c(_setup.CError, { attrs: { message: _vm.errorMsg } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }